<script>
import {mapActions, mapGetters} from "vuex";
import RichText from "@/components/ui/RichText.vue";

export default {
  name: "PortalUpdateDialog",
  components: {
    RichText,
  },
  computed: {
    ...mapGetters("portalUpdates", ["getLatestUnreadUpdate", "getSelectedUpdate", "getShowPortalUpdateDialog"]),
    showPortalUpdateDialog: {
      get() {
        return this.getShowPortalUpdateDialog;
      },
      set(show) {
        if(!show) {
          this.closeUpdateDialog();
        }
      }
    },
    header() {
      if(!this.getSelectedUpdate || !this.getSelectedUpdate.header) return null;

      if(this.getSelectedUpdate.header.formats.medium) {
        return this.baseUrl + this.getSelectedUpdate.header.formats.medium.url;
      }

      return this.baseUrl + this.getSelectedUpdate.header.url;
    },
    timestamp() {
      if(!this.getSelectedUpdate) return "";

      return new Date(this.getSelectedUpdate.created_at).toLocaleDateString("de-DE", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
      });
    }
  },
  data: () => ({
    baseUrl: process.env.VUE_APP_API_BASE_URL
  }),
  watch: {
    getLatestUnreadUpdate(newUpdate, oldUpdate) {
      if(newUpdate && !oldUpdate) {
        this.openUpdateDialog(newUpdate.id);
      }
    }
  },
  methods: {
    ...mapActions("portalUpdates", ["markAsRead", "openUpdateDialog", "closeUpdateDialog"]),
    ...mapActions("notifications", ["showNotificationsList"]),
    async onConfirmClick() {
      if(this.getSelectedUpdate) {
        await this.markAsRead(this.getSelectedUpdate.id);
      }
      this.closeUpdateDialog();
    },
    onShowAllClick() {
      this.showNotificationsList();
      this.closeUpdateDialog();
    }
  }
}
</script>

<template>
  <v-dialog v-model="showPortalUpdateDialog" width="660">
    <v-card v-if="getSelectedUpdate" class="overflow-auto">
      <v-img v-if="header" :src="header" />
      <div class="update-padding">
        <span class="timestamp-badge">Portal Update vom {{ timestamp }}</span>
        <v-card-title class="update-title pa-0 pt-2">{{ getSelectedUpdate.titel }}</v-card-title>
      </div>
      <v-card-text class="content-background update-padding pt-0">
      <rich-text class="update-text" :source="getSelectedUpdate.text" />
      </v-card-text>
      <v-card-actions class="update-actions update-padding">
        <v-btn text color="primary" @click="onShowAllClick">Alle Neuigkeiten ansehen</v-btn>
        <v-spacer></v-spacer>
        <v-btn color="primary" @click="onConfirmClick">Verstanden</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<style scoped>
.update-padding {
  padding: 12px 24px !important;
}

.update-title, .update-actions {
  font-family: "GeometriaMedium", sans-serif;
  font-size: 23px !important;
  color: #1F2B37 !important;
}

.update-text {
  font-size: 16px !important;
}

.content-background {
  border-bottom: #f2f2f3 solid 2px;
}

.timestamp-badge {
  font-size: 13px !important;
  font-family: "GeometriaMedium", sans-serif;
  background: #d5e1f1;
  padding: 2px 8px;
  border-radius: 5px;
  color: #004ba0;
}
</style>
